class EventBus {
	constructor() {
		this.listeners = new Map()
	}

	/**
	 * Subscribe to an event.
	 * Returns an unsubscribe function.
	 */
	on(topic, handler) {
		if (!this.listeners.has(topic)) {
			this.listeners.set(topic, new Set())
		}

		this.listeners.get(topic).add(handler)

		return () => this.off(topic, handler)
	}

	/**
	 * Remove a listener.
	 */
	off(topic, handler) {
		const handlers = this.listeners.get(topic)

		if (!handlers) {
			return
		}

		handlers.delete(handler)

		if (handlers.size === 0) {
			this.listeners.delete(topic)
		}
	}

	/**
	 * Emit an event to all listeners.
	 */
	emit(topic, payload) {
		const handlers = this.listeners.get(topic)

		if (handlers) {
			handlers.forEach((handler) => handler(payload))
		}

		// Optional wildcard listeners
		const wildcard = this.listeners.get('*')

		if (wildcard) {
			wildcard.forEach((handler) =>
				handler({
					topic,
					payload,
				})
			)
		}
	}

	/**
	 * Remove all listeners.
	 */
	clear() {
		this.listeners.clear()
	}
}

export default new EventBus()
